import LoginPage from '@/components/pages/Authorization/LoginPage'
import LoginConfirm from '@/components/pages/Authorization/LoginConfirm'

export default [
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/login/confirm',
    name: 'login-confirm',
    component: LoginConfirm
  }
]
